const snakeToCamel = (str) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));

const normalizeConfigs = (config) =>
  Object.entries(config).reduce((acc, [_key, value]) => {
    const key = snakeToCamel(_key);
    return { ...acc, [key]: value };
  }, {});

const {
  cart: _cart,
  offers,
  currency,
  recommendations,
  cart_item_image,
  rest_api_enabled,
  rest_api_credentials,
  server_cart_enabled,
  perlgem,
  stardust
} = window?.site?.cartConfig || {};

const cart = normalizeConfigs({
  ..._cart,
  ...offers,
  ...currency,
  ...recommendations,
  cart_item_image,
  rest_api_enabled,
  rest_api_credentials,
  server_cart_enabled
});

delete window?.site?.cartConfig;

// setting up global configs for cart component usage.
const site = window?.site || {};

site.config = {
  ...site?.config,
  cart,
  perlgem,
  stardust
};
